import { Brightness4, Brightness7 } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { useThemeMode } from '../../../theme'

export const ThemeToggle = () => {
  const { mode, toggleTheme } = useThemeMode()

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton onClick={toggleTheme} color="inherit" aria-label="toggle theme">
        {mode === 'light' ? <Brightness4 /> : <Brightness7 />}
      </IconButton>
    </Tooltip>
  )
}
